import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkHttpClient } from '../utils/httpThunkClient'

const elemetWithIdUserId = (elements: any[]) => {
  return elements.map((element) => {
    return {
      ...element,
      id: element.id + '-' + element.userId,
    }
  })
}

// Thunks for API calls
export const getAllHierarchicalElements = ThunkHttpClient.get(
  'hierarchicalElement/getAll',
  () => 'hierarchical-element/list'
)

export const getHierarchicalTree = ThunkHttpClient.get(
  'hierarchicalElement/getTree',
  () => 'hierarchical-element/tree'
)

export const getHierarchicalElementById = ThunkHttpClient.get(
  'hierarchicalElement/getById',
  (id) => `hierarchical-element/${id}`
)

export const getChildrenElements = ThunkHttpClient.get(
  'hierarchicalElement/getChildren',
  (parentId) => `hierarchical-element/parent/${parentId}/children`
)

export const getRootElements = ThunkHttpClient.get(
  'hierarchicalElement/getRoot',
  () => 'hierarchical-element/root'
)

export const createHierarchicalElement = ThunkHttpClient.post(
  'hierarchicalElement/create',
  (body) => ({ url: 'hierarchical-element/create', body })
)

export const updateHierarchicalElement = ThunkHttpClient.post(
  'hierarchicalElement/update',
  (body) => ({ url: 'hierarchical-element/update', body })
)

export const deleteHierarchicalElement = ThunkHttpClient.delete(
  'hierarchicalElement/delete',
  (id) => `hierarchical-element/${id}`
)

// Define the initial state
const initialState: any = {
  elements: [],
  treeData: [],
  loading: false,
  error: null,
  selectedElement: null,
  permissedElements: {},
}

export const hierarchicalElementSlice = createSlice({
  name: 'hierarchicalElement',
  initialState,
  reducers: {
    setSelectedElement: (state, action) => {
      state.selectedElement = action.payload
    },
    setPermissedElements: (state, action) => {
      state.permissedElements = action.payload
    },
    clearSelectedElement: (state) => {
      state.selectedElement = null
    },
  },
  extraReducers: (builder) => {
    // Get all elements
    builder.addCase(getAllHierarchicalElements.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getAllHierarchicalElements.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload) {
        state.elements = action.payload.data || action.payload
      }
    })
    builder.addCase(getAllHierarchicalElements.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Get tree
    builder.addCase(getHierarchicalTree.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getHierarchicalTree.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload) {
        state.treeData = action.payload.data || action.payload
      }
    })
    builder.addCase(getHierarchicalTree.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Get by ID
    builder.addCase(getHierarchicalElementById.fulfilled, (state, action) => {
      if (action.payload) {
        state.selectedElement = action.payload.data || action.payload
      }
    })

    // Create
    builder.addCase(createHierarchicalElement.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(createHierarchicalElement.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createHierarchicalElement.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

    // Update
    builder.addCase(updateHierarchicalElement.pending, (state) => {
      state.updateHierarchicalElementloading = true
      state.error = null
    })
    builder.addCase(updateHierarchicalElement.fulfilled, (state) => {
      state.updateHierarchicalElementloading = false
    })
    builder.addCase(updateHierarchicalElement.rejected, (state, action) => {
      state.updateHierarchicalElementloading = false
      state.error = action.error.message
    })

    // Delete
    builder.addCase(deleteHierarchicalElement.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(deleteHierarchicalElement.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(deleteHierarchicalElement.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  },
})

export const { setSelectedElement, clearSelectedElement, setPermissedElements } = hierarchicalElementSlice.actions
export default hierarchicalElementSlice.reducer



